export default {
  default: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/layouts/default.vue").then(m => m.default || m),
  iframe: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/layouts/iframe.vue").then(m => m.default || m),
  preview: () => import("/Users/yuto.yasuoka/Project/chirashi-viewer/layouts/preview.vue").then(m => m.default || m)
}